@import "../../scss";

.root {
  display: block;
  background: rgba(#fff, 0.2);
  height: 1.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 111px;
  padding: 0 0.4rem 0 0.75rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  line-height: 1;
  @include typo--small-label();
}

.heading {
  margin-right: 0.5rem;
}

.meter-outer {
  width: 6.7rem;
  height: 1rem;
  border: 2px solid var(--color-cream);
  border-radius: 111px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.meter-inner {
  height: 100%;
  background: var(--color-bright-green);
  position: absolute;
  top: 0;
  left: 0;
  will-change: width;
  transition: width 0.66s ease-in-out;
}

.meter-notch {
  width: 1px;
  height: 6px;
  background: rgba(#000, 0.2);
  position: relative;
}

.meter-notch:nth-child(2),
.meter-notch:last-child {
  visibility: hidden;
}
